(() => {
  if (window.__wrpgDealUiLoaded) return;
  window.__wrpgDealUiLoaded = true;

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function renderCountdown(el, text, isSecret) {
    el.classList.toggle("wrpg-deal-countdown--secret", isSecret);
    if (isSecret) {
      el.textContent = text;
      return;
    }
    const frag = document.createDocumentFragment();
    for (const ch of text) {
      const span = document.createElement("span");
      span.className = ch === ":" ? "wrpg-deal-digit wrpg-deal-digit--sep" : "wrpg-deal-digit";
      span.textContent = ch;
      frag.appendChild(span);
    }
    el.replaceChildren(frag);
  }

  function equalizeDealGrids() {
    document.querySelectorAll(".product-grid").forEach((grid) => {
      grid.classList.toggle(
        "wrpg-product-grid--has-deal",
        Boolean(grid.querySelector(".wrpg-deal-card")),
      );
    });
  }
  window.__wrpgEqualizeDealGrids = equalizeDealGrids;

  function fitMemberKickers() {
    document.querySelectorAll(".wrpg-deal-price-now-row").forEach((row) => {
      const kicker = row.querySelector(".wrpg-deal-price-kicker");
      if (!kicker) return;
      if (getComputedStyle(row).display === "none") return;
      const block = kicker.closest(".wrpg-deal-guest-price, .wrpg-deal-member-price, .wrpg-deal-price-block");
      if (block && getComputedStyle(block).display === "none") return;
      if (row.scrollWidth <= row.clientWidth + 0.5) return;
      let size = parseFloat(getComputedStyle(kicker).fontSize);
      const min = 7;
      while (row.scrollWidth > row.clientWidth + 0.5 && size > min) {
        size -= 0.5;
        kicker.style.fontSize = `${size}px`;
      }
    });
  }

  function expireDealUi(countdown) {
    if (countdown.dataset.wrpgExpired === "1") return;
    countdown.dataset.wrpgExpired = "1";
    const price = countdown.closest(".price");
    const card = countdown.closest(".wrpg-deal-card") || (price && price.closest(".wrpg-deal-card"));
    countdown.removeAttribute("data-wrpg-deal-end");
    countdown.remove();

    if (price) {
      price.className = price.className
        .split(/\s+/)
        .filter((cls) => cls && !cls.startsWith("wrpg-product-deal") && cls !== "wrpg-price--free")
        .join(" ");
      const list = price.getAttribute("data-wrpg-list-price") || "";
      const regular = price.querySelector(".price__regular");
      if (regular && list) {
        regular.replaceChildren();
        const span = document.createElement("span");
        span.className = "price-item price-item--regular";
        span.textContent = list;
        regular.appendChild(span);
      } else {
        price.querySelectorAll(".wrpg-deal-price-now-row, .wrpg-deal-member-price, .wrpg-deal-price-kicker").forEach((el) => {
          el.remove();
        });
        price.querySelectorAll("s.wrpg-deal-price-was").forEach((was) => {
          const span = document.createElement("span");
          span.className = "price-item price-item--regular";
          span.textContent = was.textContent || list;
          was.replaceWith(span);
        });
      }
      price.removeAttribute("data-wrpg-list-price");
    }

    if (card) {
      card.className = card.className
        .split(/\s+/)
        .filter((cls) => cls && !cls.startsWith("wrpg-deal-card"))
        .join(" ");
      card.querySelectorAll(".wrpg-deal-ribbon").forEach((ribbon) => ribbon.remove());
      card.querySelectorAll(".wrpg-subscriber-deal-form").forEach((form) => {
        form.classList.remove("wrpg-subscriber-deal-form");
      });
    }
    equalizeDealGrids();
  }

  function tickCountdowns() {
    const now = Date.now();
    document.querySelectorAll("[data-wrpg-deal-end]:not(.wrpg-deal-countdown--forever)").forEach((el) => {
      const end = Date.parse(el.getAttribute("data-wrpg-deal-end") || "");
      if (!Number.isFinite(end)) {
        renderCountdown(el, el.getAttribute("data-wrpg-secret-label") || "Hidden expiry", true);
        return;
      }
      const remaining = Math.max(0, end - now);
      if (remaining <= 0) {
        expireDealUi(el);
        return;
      }
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      renderCountdown(el, `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`, false);
    });
  }

  equalizeDealGrids();
  tickCountdowns();
  fitMemberKickers();
  window.setInterval(() => {
    equalizeDealGrids();
    tickCountdowns();
    fitMemberKickers();
  }, 1000);
  let kickerResizeTimer = 0;
  window.addEventListener("resize", () => {
    window.clearTimeout(kickerResizeTimer);
    kickerResizeTimer = window.setTimeout(() => {
      document.querySelectorAll(".wrpg-deal-price-kicker").forEach((el) => {
        el.style.fontSize = "";
      });
      fitMemberKickers();
    }, 100);
  });

  const modal = document.getElementById("wrpg-deal-modal");
  const copyEl = document.getElementById("wrpg-deal-modal-copy");
  const guestCopy = document.getElementById("wrpg-deal-modal-guest");
  const memberCopy = document.getElementById("wrpg-deal-modal-member");
  const guestActions = document.querySelector("[data-wrpg-deal-guest-actions]");
  const memberActions = document.querySelector("[data-wrpg-deal-member-actions]");
  const plansEl = document.querySelector("[data-wrpg-deal-plans]");
  let membershipPlansPromise = null;

  function loadMembershipPlans() {
    if (!membershipPlansPromise) {
      membershipPlansPromise = fetch("/apps/wrpg/membership-products")
        .then((res) => (res.ok ? res.json() : { products: [] }))
        .then((data) => (Array.isArray(data.products) ? data.products : []))
        .catch(() => []);
    }
    return membershipPlansPromise;
  }

  function modalPlanLabel(product) {
    if (product.modalLabel) return product.modalLabel;
    const cents = Number(product.creditAmountCents);
    if (Number.isFinite(cents) && cents > 0) {
      const amount = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
      const symbol = product.currency === "EUR" ? "€" : "£";
      return `Get ${symbol}${amount} monthly credit`;
    }
    return product.label || product.title || "";
  }

  function renderPlans(products) {
    if (!plansEl) return;
    plansEl.replaceChildren();
    const sorted = [...products].sort(
      (a, b) => (Number(a.creditAmountCents) || 0) - (Number(b.creditAmountCents) || 0),
    );
    sorted.forEach((product) => {
      const href = product.url || (product.handle ? `/products/${product.handle}` : "");
      if (!href) return;
      const link = document.createElement("a");
      link.className = "button";
      link.href = href;
      link.textContent = modalPlanLabel(product);
      plansEl.appendChild(link);
    });
  }

  function openDealModal() {
    if (!modal) return;
    if (document.documentElement.getAttribute("data-wrpg-member") === "1") return;
    const loggedIn = document.documentElement.getAttribute("data-wrpg-logged-in") === "1";
    if (copyEl) {
      const source = loggedIn ? memberCopy : guestCopy;
      copyEl.textContent = source ? source.textContent : copyEl.textContent;
    }
    if (guestActions) guestActions.hidden = loggedIn;
    if (memberActions) memberActions.hidden = !loggedIn;
    modal.setAttribute("open", "");
    if (loggedIn) {
      loadMembershipPlans().then(renderPlans);
    }
  }

  function closeDealModal() {
    if (modal) modal.removeAttribute("open");
  }

  document.addEventListener("wrpg:subscriber-deal-added", openDealModal);

  document.addEventListener("click", (event) => {
    if (event.target === modal) {
      closeDealModal();
      return;
    }
    if (event.target.closest("[data-wrpg-deal-close]")) {
      event.preventDefault();
      closeDealModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal && modal.hasAttribute("open")) closeDealModal();
  });
})();
